import { getRelativeBasePath } from 'util/history';

export const getPortalSettingsBaseRoute = () => `${getRelativeBasePath()}/portal/customize/sidebar`;

export const getPortalSettingsIndexRoute = () => '/';
export const getPortalSettingsRequestGroupsRoute = () => `${getPortalSettingsBaseRoute()}/request-groups`;
export const getPortalSettingsRequestGroupDetailRoute = (requestGroupId: number) =>
    `${getPortalSettingsBaseRoute()}/request-groups/${requestGroupId}`;
export const getPortalSettingsRequestTypeDetailRoute = (requestGroupId: number, requestTypeId: number) =>
    `${getPortalSettingsBaseRoute()}/request-groups/${requestGroupId}/request-types/${requestTypeId}`;
export const getPortalSettingsRequestTypeDetailOrphanRoute = (requestTypeId: number) =>
    `${getPortalSettingsBaseRoute()}/request-types/${requestTypeId}`;

export { SidebarHeader } from './styled';
export { default } from './messages';
